export default __webpack_public_path__ + "static/media/wheel.770e530f.png";